






























import Vue from 'vue'
import PersonProperty from '@/types/PersonProperty.interface'
import { mapGetters } from 'vuex'
export default Vue.extend({
    props: {
        isTemplate: {
            type: Boolean,
            required: false,
            default: null
        }
    },
    data() {
        return {
            selectedProperties: []
        }
    },
    mounted() {},
    computed: {
        ...mapGetters([
            'personProperties',
            'qboHasAccount',
            'dataProviderPhones',
            'xeroHasAccount'
        ]),
        properties(): PersonProperty[] {
            //  Check if we have a data provider
            const provider = this.qboHasAccount || this.xeroHasAccount

            //  If we have a provider AND properties AND provider phones AND this is NOT a template, add provider phones to properties
            const cond =
                provider &&
                this.personProperties &&
                this.dataProviderPhones &&
                !this.isTemplate

            //  If a qbo or xero tenant, add home, work, and home fax phones to export
            if (cond) return this.personProperties.concat(this.dataProviderPhones)

            //  If not qbo or xero, push default person properties
            if (this.personProperties) return this.personProperties

            //  Return null if person properties not loaded yet
            return null
        }
    },
    methods: {
        dispatchExport(): void {
            //  User has to select at least 1 field to export
            if (this.selectedProperties.length < 1) {
                return this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Error',
                    icon: 'mdi-alert',
                    color: 'red',
                    text: 'Please select at least one field to export'
                })
            }

            //  If a CSV template download and the 'Phone Number' field is not chosen, pop warning dialog
            if (this.isTemplate) {
                //  Try to find Phone Number property
                const mobilePhone = this.selectedProperties.find(
                    (property: PersonProperty) => property.name === 'Phone Number'
                )

                //  If no phone number pop dialog
                if (!mobilePhone)
                    return this.$store.dispatch('dialogOpen', {
                        type: 'CONFIRM',
                        title: 'Warning',
                        text: "You chose not to include 'Phone Number' in your template. You will be required to match this field to a column from your CSV file in the next step. Are you sure you want to continue?",
                        icon: 'mdi-alert',
                        color: 'primary',
                        callback: (dialog_result: boolean): void => {
                            //  If false, do nothing
                            if (!dialog_result) return

                            //  Begin export
                            this.$emit('submit', this.selectedProperties)
                        }
                    })
            }

            //  Begin export
            this.$emit('submit', this.selectedProperties)
        },
        selectAll(bool: boolean): void {
            //  Check if we have a provider
            const provider = this.qboHasAccount || this.xeroHasAccount

            //  Our condition is if we have a provider and this is NOT a template
            const cond = provider && !this.isTemplate

            //  If select all = no, set selectedProperties to empty array (uncheck everything)
            if (!bool) this.selectedProperties = []
            //  If provider is false, then set our selected properties to person properties
            else if (!cond) this.selectedProperties = this.personProperties
            //  else, if select all = yes, set selectedProperties to all personProperties (check everything)
            else {
                this.selectedProperties = this.personProperties.concat(
                    this.dataProviderPhones
                )
            }
        }
    }
})
